__turbopack_context__.v({
  "backdrop": "OverflowMenu-module__hhmdca__backdrop",
  "item": "OverflowMenu-module__hhmdca__item",
  "itemActive": "OverflowMenu-module__hhmdca__itemActive",
  "itemDisabled": "OverflowMenu-module__hhmdca__itemDisabled",
  "menu": "OverflowMenu-module__hhmdca__menu",
  "soon": "OverflowMenu-module__hhmdca__soon",
  "trigger": "OverflowMenu-module__hhmdca__trigger",
  "triggerOpen": "OverflowMenu-module__hhmdca__triggerOpen",
});
